import { cn } from '@/lib/utils';

/**
 * "EiFO Academy" rendered in the multi-color palette of the brain-tree logo
 * (green / cyan / blue / orange / red / magenta / purple). Each glyph is its
 * own colored span; the concatenated text still reads as "EiFO Academy" to
 * screen readers, so no extra aria wiring is needed.
 */
const EIFO: ReadonlyArray<readonly [string, string]> = [
  ['E', '#06b6d4'], // cyan
  ['i', '#fc800a'], // orange
  ['F', '#2563eb'], // blue
  ['O', '#d6249f'], // magenta
];

const ACADEMY: ReadonlyArray<readonly [string, string]> = [
  ['A', '#2563eb'], // blue
  ['c', '#06b6d4'], // cyan
  ['a', '#22c55e'], // green
  ['d', '#84cc16'], // lime
  ['e', '#fc800a'], // orange
  ['m', '#ec4899'], // pink
  ['y', '#9333ea'], // purple
];

export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={cn('font-display font-bold tracking-tight', className)}>
      {EIFO.map(([ch, color], i) => (
        <span key={`e${i}`} style={{ color }}>
          {ch}
        </span>
      ))}
      <span>&nbsp;</span>
      {ACADEMY.map(([ch, color], i) => (
        <span key={`a${i}`} style={{ color }}>
          {ch}
        </span>
      ))}
    </span>
  );
}
